import { FC, useContext, useState } from 'react';

import { AlertIcon, Button, Tooltip } from '@smartshell/ui-kit';
import cn from 'classnames';
import dayjs from 'dayjs';

import { LocalizationContext } from 'localization';
import { getUserFIO } from 'utils';

import { ICommentProps } from '../interfaces';
import s from './Comment.module.scss';

export const Comment: FC<ICommentProps> = ({
  comment: { text, created_at, author, id, is_important },
  deleteComment,
  permissions,
  updateComment,
}) => {
  const { t } = useContext(LocalizationContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isHover, setIsHover] = useState<boolean>(false);

  return (
    <div
      className={cn(s.container)}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => setIsHover(false)}
    >
      <header className={s.header}>
        <div className={s.left}>
          <div>{getUserFIO(author)}</div>
          <div className={s.date}>
            <span>{dayjs(created_at).format('DD.MM.YYYY')}</span>
            <span>{dayjs(created_at).format('HH:mm')}</span>
          </div>
        </div>
        <div className={s.header_right}>
          {(is_important || isHover) && (
            <div
              className={s.important}
              onClick={() => {
                updateComment(id, !is_important);
              }}
            >
              <Tooltip
                contentClassName={s.tooltip}
                content={
                  !is_important
                    ? t('important.check')
                    : t('important.check.non')
                }
              >
                <AlertIcon color={!is_important ? 'secondary' : 'warning'} />
              </Tooltip>
            </div>
          )}
          {permissions?.has('comment_delete') && (
            <Button
              variant="ghost"
              className={s.delete_button}
              onClick={() => {
                setIsDeleting(true);
                deleteComment(id).finally(() => setIsDeleting(false));
              }}
              color="red"
              disabled={isDeleting}
              iconName="BucketIcon"
            />
          )}
        </div>
      </header>
      <div className={s.text}>{text}</div>
    </div>
  );
};
